import { Button } from "@/components/ui/button";
import type { EventsView } from "@/lib/event-pipeline";
import { EventsViewTabs } from "./EventsViewTabs";

interface EventsHeaderProps {
  view: EventsView;
  onViewChange: (v: EventsView) => void;
  search: string;
  onSearchChange: (term: string) => void;
  onNewEvent: () => void;
}

/** One header for Pipeline and List: title, + New event, the view switch and search (#1557). */
export function EventsHeader({ view, onViewChange, search, onSearchChange, onNewEvent }: EventsHeaderProps) {
  return (
    <>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Events</h1>
          <p className="text-sm text-muted-foreground">
            One card per event. Quotes, payments and messages live inside it.
          </p>
        </div>
        <Button type="button" onClick={onNewEvent} className="font-semibold">
          + New event
        </Button>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <EventsViewTabs value={view} onChange={onViewChange} />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search client, occasion or quote #"
          aria-label="Search events"
          className="min-w-0 max-w-[340px] flex-[1_1_220px] rounded-lg border bg-card px-[11px] py-[7px] text-sm max-sm:max-w-none"
        />
      </div>
    </>
  );
}
